<template>
  <vx-card>
    <div class="vx-row">
      <div v-bind:class="[detail ? detailShow : '', detailHide]">
        <div class="vx-col sm:w-1/1 w-full mb-base">
          <vs-tabs>
            <vs-tab label="GL Monitoring">
              <div class="tab-text">
                <div class="vx-row mb-6" style="width: 70%">
                  <div class="vx-col sm:w-1/3 w-full flex items-center">
                    <span>Operating Unit</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <multiselect
                      class="selectExample"
                      v-model="ouCodeSelected"
                      :options="optionOu"
                      :allow-empty="true"
                      :group-select="false"
                      :max-height="120"
                      :limit="3"
                      :custom-label="customQuery"
                      track-by="Name"
                      label="Name"
                      multiple
                    >
                    </multiselect>
                  </div>
                </div>
                <div class="vx-row mb-6" style="width: 70%">
                  <div class="vx-col sm:w-1/3 w-full flex items-center">
                    <span>Period</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <datepicker
                      style="min-height: 40px"
                      class="w-full"
                      v-model="filterPeriodSelected"
                      :format="monthYearFormat"
                      :minimum-view="'month'"
                      :maximum-view="'year'"
                      :initial-view="'month'"
                      placeholder="Select Period"
                    ></datepicker>
                  </div>
                </div>
                <div class="vx-row mb-6" style="width: 70%">
                  <div class="vx-col sm:w-1/3 w-full flex items-center">
                    <span>COA</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <multiselect
                      class="selectExample"
                      v-model="coaCodeSelected"
                      :options="optionCoa"
                      :allow-empty="true"
                      :group-select="false"
                      :max-height="120"
                      :limit="3"
                      :custom-label="customQuery"
                      track-by="Name"
                      label="Name"
                      multiple
                    >
                    </multiselect>
                  </div>
                </div>
                <div class="vx-row mb-6" style="width: 70%">
                  <div class="vx-col sm:w-1/3 w-full flex items-center">
                    <div class="flex items-center">
                      <span>Last Update</span>
                    </div>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <vs-input
                      class="w-full info-field-input"
                      v-model="lastUpdate"
                      readonly
                      icon="icon-clock"
                      icon-pack="feather"
                      icon-after
                      placeholder="No data available"
                    />
                  </div>
                </div>
                <div class="vx-row mb-6" style="width: 70%">
                  <div class="vx-col sm:w-1/3 w-full flex items-center">
                    <div class="flex items-center">
                      <span>Updated By</span>
                    </div>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <vs-input
                      class="w-full info-field-input"
                      v-model="updatedBy"
                      readonly
                      icon="icon-user"
                      icon-pack="feather"
                      icon-after
                      placeholder="No data available"
                    />
                  </div>
                </div>
                <data-table
                  :baseUrl="this.baseUrl"
                  :detail="this.detail"
                  :filter-period="this.filterPeriod"
                  :coa-code="this.coaCode"
                  :ou-code="this.ouCode"
                  :last-update="lastUpdate"
                  @update-last-update="getLastUpdate"
                ></data-table>
              </div>
            </vs-tab>
            <vs-tab label="Export">
              <div class="tab-text">
                <data-table-export :type="'gl-monitoring-trx'"></data-table-export>
              </div>
            </vs-tab>
          </vs-tabs>
        </div>
      </div>
      <!-- <transition name="detail-fade">
        <div
          v-if="detail"
          v-bind:class="[detail ? detailShow : '', detailHide]"
        >
          <vs-row>
            <vs-col
              style="padding-bottom: 8px"
              vs-offset="8"
              vs-type="flex"
              vs-justify="rigth"
              vs-align="rigth"
              vs-w="4"
            >
              <vs-button
                class="ml-auto"
                size="small"
                v-on:click="handleClose"
                color="grey"
                icon-pack="feather"
                icon="icon-x-square"
                >Close</vs-button
              >
            </vs-col>
            <vs-col
              class="vertical-divider"
              vs-offset="0"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="1"
            >
              <vs-button
                size="small"
                v-on:click="handleClose"
                color="grey"
                icon-pack="feather"
                icon="icon-x-square"
              ></vs-button>
            </vs-col>
          </vs-row>
        </div>
      </transition> -->
    </div>
  </vx-card>
</template>
<script>
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import Datepicker from 'vuejs-datepicker';
import DataTable from "./DataTableByTrx.vue";
import DataTableExport from "./DataTableExport.vue";
import moment from "moment";
export default {
  components: {
    DataTableExport,
    DataTable,
    Datepicker
  },
  data() {
    return {
      detailShow: "core vx-col md:w-1/2 w-full mb-base ",
      detailHide: "core vx-col md:w-1/1 w-full mb-base ",
      detail: false,

      lastUpdate: null,
      updatedBy: null,
      
      ouCodeSelected: [],
      coaCodeSelected: [],
      ouCode: [],
      coaCode: [],
      baseUrl: "/api/v1/report/gl-monitoring",

      filterPeriod: null,
      filterPeriodSelected: null,
      optionOu: [],
      optionCoa: [],
      draw: 0
    };
  },
  methods: {
    customQuery({ Name, Code }) {
      if (!Name || !Code) {
        return "Select options";
      } else if (Name === "All") {
        return `${Code} - ${Name}`;
      }
      return `${Code} - ${Name}`;
    },
    getOptionOperatingUnit() {
      this.$vs.loading();
      this.$http
        .get("/api/v1/master/operating-unit-with-territory/personal", {
          params: {
            is_include_ho: true,
            order: "name",
            sort: "asc",
          },
        })
        .then((resp) => {
          if (resp.code == 200) {
            this.optionOu = []
            this.optionOu = resp.data.records;
          } else {
            this.$vs.notify({
              title: "Error",
              text: "Failed to get operating unit options",
              color: "danger",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
          }
          this.$vs.loading.close();
        });
    },
    getOptionCoa() {
      this.$vs.loading();
      this.$http
        .get("/api/v1/master/chart-of-account")
        .then((resp) => {
          if (resp.code == 200) {
            let coa = [];
            resp.data.records.map((v, i) => {
                const option = {
                  Name: v.coa.Name,
                  Code: v.coa.Code,
                }
                coa.push(option);
            });
            this.optionCoa = coa;
          } else {
            this.$vs.notify({
              title: "Error",
              text: "Failed to get COA option",
              color: "danger",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
          }
          this.$vs.loading.close();
        });
    },
    // handleClose() {
    //   this.detail = false;
    // },
    // handleOpen() {
    //   this.detail = true;
    // },
    // dateFormat(date) {
    //   let a = null;
    //   if (date != null) {
    //     a = moment(date).format("MMM DD, YYYY");
    //   }
    //   return a;
    // },
    monthYearFormat(date) {
      let a = null;
      if (date != null) {
        a = moment(date).format("MMM YYYY");
      }
      return a;
    },
    getLastUpdate(period) {
      this.$vs.loading();
      this.$http
        .get("/api/v1/report/gl-monitoring/last-update-trx", {
          params: {
            period: period,
            coas: this.coaCode.join(","),
            ous: this.ouCode.join(","),
          }
        })
        .then((resp) => {
          if (resp.code == 200) {
            this.lastUpdate = resp.data.updated_at;
            this.updatedBy = resp.data.updated_by;
          } else {
            this.$vs.notify({
              title: "Error",
              text: "Failed to get last update",
              color: "danger",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
          }
          this.$vs.loading.close();
        });
    },
    // handleDrawTable() {
    //   this.draw++;
    // },
    // handlePeriodChange() {
    //   this.draw++;
    // }
  },
  mounted() {
    const today = new Date();
    this.filterPeriodSelected = new Date(today.getFullYear(), today.getMonth(), 1);
    const year = this.filterPeriodSelected.getFullYear();
    const month = String(this.filterPeriodSelected.getMonth() + 1).padStart(2, '0');
    this.filterPeriod = `${year}-${month}`;
    // this.draw++;

    this.getOptionOperatingUnit();
    this.getOptionCoa();
    // this.getLastUpdate(this.filterPeriod);
  },
  watch: {
    ouCodeSelected() {
      if (this.ouCodeSelected && this.ouCodeSelected.length > 0) {
        this.ouCode = this.ouCodeSelected.map(item => item.Code);
      } else {
        this.ouCode = [];
      }

      this.getLastUpdate(this.filterPeriod);
    },
    coaCodeSelected() {
      if (this.coaCodeSelected && this.coaCodeSelected.length > 0) {
        this.coaCode = this.coaCodeSelected.map(item => item.Code);
      } else {
        this.coaCode = [];
      }

      this.getLastUpdate(this.filterPeriod);
    },
    filterPeriodSelected() {
      if (this.filterPeriodSelected) {
        const year = this.filterPeriodSelected.getFullYear();
        const month = String(this.filterPeriodSelected.getMonth() + 1).padStart(2, '0');
        this.filterPeriod = `${year}-${month}`;
      }

      // get last update and updated by
      this.getLastUpdate(this.filterPeriod);
    }
  }
};
</script>

<style scoped>
.core-enter-active {
  transition: all 0.3s ease;
}
.core-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.core-enter, .core-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.core {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  transition: all 1s ease;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 12px;
}
.vertical-divider {
  border-left: 1px solid #7367f0;
  min-height: 800px;
  padding: 5px;
}

/* Custom styling for info fields */
.info-field-label {
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #4a5568;
}

.info-field-input .vs-input--input {
  background-color: #f7fafc;
  border-color: #e2e8f0;
  color: #2d3748;
  font-weight: 500;
}

.info-field-input .vs-input--input:focus {
  border-color: #7367f0;
  box-shadow: 0 0 0 3px rgba(115, 103, 240, 0.1);
}

.info-field-input .vs-input--icon {
  color: #718096;
}
</style>
